import * as React from 'react';
import {forwardRef} from 'react';
import classNames from 'classnames';

import './style.scss';

import {Icon} from 'components/atoms/Media/Icon';
import {Button, ButtonColor, ButtonSize, ButtonType} from '@atoms/LinksAndButtons/Button';

interface Props {
    playing: boolean;
    onClick?: React.MouseEventHandler<HTMLButtonElement>;
    small?: boolean;
    className?: string;
    id?: string;
}
export const PlayPause = forwardRef<HTMLButtonElement, Props>(({playing, onClick, small, className, id}, ref) => {
    const buttonClasses = classNames('pause-play-button', className, {
        'pause-play-button--small': small,
        'pause-play-button--play': !playing,
        'pause-play-button--pause': playing,
    });

    return (
        <Button 
            id={id} 
            className={buttonClasses} 
            ref={ref} 
            onClick={onClick} 
            icon={<Icon name={playing ? "pause" : "play"} />} 
            iconBtn 
            buttonColor={ButtonColor.LIGHT} 
            buttonSize={ButtonSize.DEFAULT} 
            buttonType={ButtonType.DEFAULT}
        >
            {playing ? "Pause" : "Play"}
        </Button>
    )
});
